import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore } from '@lib/store';
import { cn } from '@shared/utils';
import { UserType } from '@shared/api';
import { Icon, Text } from '@shared/widgets';
import AccountIcon from '@assets/icons/account.svg';
import CardIcon from '@assets/icons/card.svg';

interface ShortInfoProps {
  className?: string;
  type: UserType;
  locked: boolean;
  cards: number;
  accounts: number;
}

export const ShortInfo = (props: ShortInfoProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const { t } = useTranslation('userManagement');

  if (props.type === UserType.Admin || !profileFeatureStore.data?.userManagement.managerAccountsOrCardsPermissions) return null;
  return (
    <div className={cn('border-t border-t-gray-black px-6 pb-6 pt-8', props.locked && 'pointer-events-none select-none opacity-50', props.className)}>
      <div className='flex gap-4'>
        <div className='flex items-center gap-2'>
          <Icon
            className='flex h-8 w-8 flex-none items-center justify-center bg-ice dark:bg-eerie-black'
            color='secondary-inverse'
            icon={<AccountIcon />}
          />
          <Text>{t('user.info.userType.manager', { count: props.accounts })}</Text>
        </div>
        {props.type === UserType.User && (
          <div className='flex items-center gap-2'>
            <Icon
              className='flex h-8 w-8 flex-none items-center justify-center bg-ice dark:bg-eerie-black'
              color='secondary-inverse'
              icon={<CardIcon />}
            />
            <Text>{t('user.info.userType.user', { count: props.cards })}</Text>
          </div>
        )}
      </div>
    </div>
  );
};
